import React from 'react';
import { variables } from '../../../utils';

const BinaryMiniViz: React.FC<{ value: 0 | 1 }> = ({ value }) => (
  <>
    {value === 1 && (
      <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" style={{ width: 12, height: 12 }}>
        <path
          d="M6,0C2.7,0,0,2.7,0,6s2.7,6,6,6s6-2.7,6-6S9.3,0,6,0z M5.8,9.2L3.3,6.6L4,5.9l1.5,1.6l2.4-4.1l0.9,0.5L5.8,9.2z"
          fill={variables.blue}
        />
      </svg>
    )}

    {value === 0 && (
      <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" style={{ width: 12, height: 12 }}>
        <g>
          <path
            d="M6,0C2.7,0,0,2.7,0,6s2.7,6,6,6s6-2.7,6-6S9.3,0,6,0z M6,11c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S8.8,11,6,11 z"
            fill={variables.blue}
          />
          <polygon
            points="7.9,3.4 6,5.3 4.1,3.4 3.4,4.1 5.3,6 3.4,7.9 4.1,8.6 6,6.7 7.9,8.6 8.6,7.9 6.7,6 8.6,4.1"
            fill={variables.blue}
          />
        </g>
      </svg>
    )}
  </>
);

export default BinaryMiniViz;
